export const formatPrice = (price: string): string => {
    return Number.parseFloat(price).toFixed(2).replace('.', ',');
};
